import { observer } from 'mobx-react-lite';
import { ChangeEvent, SubmitEventHandler, useId, useState } from 'react';
import styled from '@emotion/styled';
import { SearchInput } from '../../../components/common/search-input/SearchInput';
import Button from '../../../components/common/button/Button';
import { ContentWrap, Css, Responsive } from '../../../ui';
import { Color } from '../../../styles/Color';

interface IProps {
	defaultQuery: string;
	onSubmit: (query: string) => void;
}

export const SearchInputForm = observer(
	({ defaultQuery, onSubmit }: IProps) => {
		const [query, setQuery] = useState(defaultQuery);
		const labelId = useId();

		const handleOnSubmit: SubmitEventHandler = (event) => {
			event.preventDefault();
			onSubmit(query);
		};

		const handleOnClear = () => {
			setQuery('');
			onSubmit('');
		};

		return (
			<StyledWrap>
				<ContentWrap>
					<StyledForm onSubmit={handleOnSubmit}>
						<StyledSearchInput
							type="text"
							label="Search for anything"
							labelId={labelId}
							value={query}
							onChange={(e: ChangeEvent<HTMLInputElement>) =>
								setQuery(e.target.value)
							}
							onClear={handleOnClear}
							autoFocus
						/>

						<StyledButton type="submit" ariaLabel="Search">
							Search
						</StyledButton>
					</StyledForm>
				</ContentWrap>
			</StyledWrap>
		);
	},
);

const StyledWrap = styled.div`
	width: 100%;
	margin-top: ${Css.pxToRem(16)};
`;

const StyledForm = styled.form`
	display: flex;
	border: none;
	padding: 0;
	margin: 0;
	gap: ${Css.pxToRem(16)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		gap: ${Css.pxToRem(8)};
		align-items: end;
	}
`;

const StyledSearchInput = styled(SearchInput)`
	color: ${Color.OnBackground};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		max-height: ${Css.pxToRem(48)};
	}
`;

const StyledButton = styled(Button)`
	height: ${Css.pxToRem(56)};
	white-space: nowrap;
	justify-content: center;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		height: ${Css.pxToRem(48)};
		max-width: ${Css.pxToRem(48)};
		width: 100%;
		padding: 0 !important;

		svg {
			overflow: visible;
		}
		& > div {
			display: none;
		}
	}
`;
